import React from 'react'
import Modal from 'react-modal'
import update from 'immutability-helper'
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import { property } from '../../core/controllers/Property';
import { modalStyles } from '../../core/controllers/ModalStyles';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.storage_id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class PropertyOwnerEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            propertyId : props.propertyId,
            image: null,
            sortID: null,
            property: {
                property_type: 0,
                name: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                qb_custom_ref_id: '',
                owner_id: 0,
                fee_id: 0,
                bank_identifier: 0
            },
            singleUnit: true,
            totalUnits: [],
            showModal: false,
            unitData : {
                id: 0,
                name: '',
                sqFootage: '',
                bedrooms: '',
                bathrooms: '',
                lease: '',
            },
        };
    }

    componentDidMount() {
        var self = this;
        property.getProperty(this.props.propertyId, function(response) {
            const details = response.data.details;
            const bank_account = response.data.bank_account;
            var singleUnit = true;
            var property = {
                property_type: details.property_type,
                name: details.property_name,
                address: details.property_address,
                city: details.property_city,
                state: details.property_state,
                zipcode: details.property_zip,
                qb_custom_ref_id: details.qb_custom_ref_id,
                owner_id: details.owner_id,
                fee_id: details.fee_id,
                bank_identifier: bank_account ? bank_account.bank_identifier : 0
            };

            var formattedUnited = [];
            if (response.data.units_tally > 0) {
                const units = response.data.units;
                formattedUnited = units.map((item, key) => {
                    var unit = {name: item.unit_name, id: item.property_unit_id}
                    return unit;
                });
                singleUnit = false;
            }
            self.setState({
                property: property,
                image: response.data.photo,
                totalUnits: formattedUnited,
                singleUnit: singleUnit,
                feeDetails: response.data.fee,
            })
        });
    }

    renderAttachment(image) {
        if (image !== null && image != false) {
            return <Attachment attachment={image} />
        }
        else return (<p>No property cover photo found. </p>);
    }


    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    updateUnitData(value) {
        const totalUnits = this.state.totalUnits;

        totalUnits.map((item, key) => {
            if (item.id == value) {
                this.setState ({
                    unitData: update(this.state.unitData, {
                        id: {$set: item.id},
                        name: {$set: item.name},
                        sqFootage: {$set: ''},
                        bedrooms: {$set: ''},
                        bathrooms: {$set: ''},
                        lease: {$set: ''},
                    })
                });
            }
        })
    }

    handleOpenModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({
            showModal: false,
        });
    }

    didSelectRow(row) {
        this.setState ({
            unitData: update(this.state.unitData, {
                id: {$set: row.id}
            })
        });
        this.updateUnitData(row.id);
        this.setState({ showModal: true });
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        const image = this.renderAttachment(this.state.image);
        const propertyName = this.state.property.name;
        const propertyType = this.state.property.property_type;
        const address = this.state.property.address;
        const city = this.state.property.city;
        const state = this.state.property.state;
        const zipcode = this.state.property.zipcode;
        const totalUnits = this.state.totalUnits;
        const singleUnit = this.state.singleUnit;
        const options = {
            onRowClick: this.didSelectRow.bind(this)
        };

        return (
        <div>
            <div class="row blue-bottom-margin">
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{propertyName}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Property Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label for="assignee">Property Name</label>
                                                    <input disabled type="text" value={propertyName} class="form-control" name="title" placeholder="Backster building..." id="title" />
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1">
                                                <div class="form-group">
                                                    <label>Property Type</label>
                                                    <input disabled type="text" class="form-control" value={propertyType} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label for="address">Address</label>
                                                    <input disabled type="text" class="form-control" value={address} placeholder="10000 Marshall Dr." />
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="city">City</label>
                                                    <input disabled type="text" class="form-control" value={city} name="city" placeholder="Lenexa" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <UnitedStatesSelect disabled columnSize={0} sortID={state} title="State" />
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="address">Zipcode</label>
                                                    <input disabled type="text" class="form-control" value={zipcode} placeholder="62472" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-picture"></i></span> Photos</h4>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="content">
                                            { image }
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
                { singleUnit == false && (
                <div class="col-md-12">
                    <div class="card">
                        <div class="row">
                            <Modal
                                isOpen={this.state.showModal}
                                onRequestClose={this.handleCloseModal.bind(this)}
                                style={modalStyles.getModalStyles()}
                                ariaHideApp={false}
                            >
                                <div class="row">
                                    <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                                </div>
                                <div class="row">
                                    <div class="modal-header">{this.state.unitData.name}</div>
                                </div>
                                <div class="row">
                                    <div class="modal-section-title col-md-5">Unit Information</div>
                                </div>
                                <form>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Unit Name</label>
                                                <input type="text" disabled value={this.state.unitData.name} class="form-control" name="unit_name" placeholder="Unit 101" id="unit_name"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </Modal>
                            <div class="col-md-12">
                                <div class="header">
                                    <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-unit-box"></i></span> Units</h4>
                                    <p class="category">List of all units at the property</p>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            {totalUnits.length > 0 ? (
                            <div>
                                {window.innerWidth < 992 ? (
                                <BootstrapTable data={totalUnits} version='4' striped search pagination hover options={options}>
                                    <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='name' dataSort={ true }>Title</TableHeaderColumn>
                                </BootstrapTable>
                                ) : (
                                <BootstrapTable data={totalUnits} version='4' striped search pagination hover options={options}>
                                    <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='name' dataSort={ true }>Title</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>Bed</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>Bath</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>SQ Footage</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>Lease</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>Lease Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='' dataSort={ true }>Photos</TableHeaderColumn>
                                </BootstrapTable>
                                )}
                                <div class="clearfix"></div>
                            </div>
                            ) : (
                            <div style={{textAlign: "center"}}>
                                <div class="row">
                                    <div class="main-page-header-row col-md-12">
                                        <div class="row" style={{marginTop: "10px"}}>
                                            <span class="main-page-header-title no-units-message">No Units Yet</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
                )}
            </div>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/Properties/PropertyOwnerEdit.jsx